/* =============================================================
   MEGA MENU — assets/mega-menu.js
   No "defer" attribute — load as: <script src="{{ 'mega-menu.js' | asset_url }}"></script>
   ============================================================= */
(function () {
  'use strict';

  /* ── Early CSS to block Dawn's dropdown flash ── */
  var earlyStyle = document.createElement('style');
  earlyStyle.textContent =
    'header-menu li[data-mega-trigger]>details>ul,' +
    'header-menu li[data-mega-trigger]>details>div,' +
    '.header__menu-item[data-mega-trigger]>details>ul,' +
    '.header__menu-item[data-mega-trigger]>details>div,' +
    'header-menu li[data-mega-trigger] .icon-caret,' +
    '.header__menu-item[data-mega-trigger] .icon-caret{display:none!important}';
  document.head.appendChild(earlyStyle);

  /* ── Handles from section settings ── */
  var handles = (window.megaMenuHandles || 'shop')
    .split(',').map(function(h){ return h.trim().toLowerCase(); }).filter(Boolean);

  /* ── Desktop elements ── */
  var panel    = document.getElementById('megaMenuPanel');
  var backdrop = document.getElementById('megaMenuBackdrop');
  var closeBtn = document.getElementById('megaMenuClose');
  if (!panel) return;

  var isOpen = false, closeTimer = null, bound = false, mobileBound = false;

  /* ─────────────────────────────────────────────────
     HELPERS
  ───────────────────────────────────────────────── */
  function getHeaderBottom() {
    var el = document.querySelector('sticky-header') ||
             document.querySelector('#shopify-section-header') ||
             document.querySelector('header.header') ||
             document.querySelector('header');
    return el ? el.getBoundingClientRect().bottom : 80;
  }

  function isMatch(text) {
    return handles.some(function(h){ return (text||'').trim().toLowerCase() === h; });
  }

  function isMobile() { return window.innerWidth <= 989; }

  /* ─────────────────────────────────────────────────
     DESKTOP: open / close
  ───────────────────────────────────────────────── */
  function openMenu() {
    clearTimeout(closeTimer);
    if (isOpen || isMobile()) return;
    isOpen = true;
    panel.style.top = getHeaderBottom() + 'px';
    panel.classList.add('is-active');
    backdrop.classList.add('is-active');
  }

  function closeMenu() {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('is-active');
    backdrop.classList.remove('is-active');
  }

  function scheduleClose() { clearTimeout(closeTimer); closeTimer = setTimeout(closeMenu, 150); }
  function cancelClose()   { clearTimeout(closeTimer); }

  /* ─────────────────────────────────────────────────
     DESKTOP: mark trigger <li> elements early
     so the earlyStyle CSS hides Dawn's dropdown
     before first paint
  ───────────────────────────────────────────────── */
  function markTriggers() {
    document.querySelectorAll([
      'header-menu nav a',
      'header-menu nav summary',
      '.header__menu-item > a',
      '.header__menu-item > details > summary'
    ].join(',')).forEach(function(el) {
      var text = (el.querySelector('span') || el).textContent;
      if (!isMatch(text)) return;
      var li = el.closest('li') || el.parentElement;
      if (li) li.setAttribute('data-mega-trigger', 'true');
    });
  }

  /* ─────────────────────────────────────────────────
     DESKTOP: bind hover events on trigger <li>
  ───────────────────────────────────────────────── */
  function bindDesktopTriggers() {
    if (bound) return;

    var candidates = document.querySelectorAll([
      'header-menu nav a',
      'header-menu nav summary',
      '.header__menu-item > a',
      '.header__menu-item > details > summary',
      'nav.header__inline-menu a',
      'nav.header__inline-menu summary'
    ].join(','));

    if (!candidates.length) { setTimeout(bindDesktopTriggers, 200); return; }

    candidates.forEach(function(el) {
      var text = (el.querySelector('span') || el).textContent;
      if (!isMatch(text)) return;
      var li = el.closest('li') || el.parentElement;
      if (!li || li.dataset.megaMenuBound) return;
      li.dataset.megaMenuBound = 'true';

      li.addEventListener('mouseenter', openMenu);
      li.addEventListener('mouseleave', scheduleClose);

      /* Suppress Dawn's <details> dropdown */
      var details = li.querySelector('details');
      if (details) {
        details.addEventListener('toggle', function() {
          if (details.open) details.removeAttribute('open');
        }, true);
        var summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }, true);
        }
      }
    });

    bound = true;
  }

  /* ─────────────────────────────────────────────────
     MOBILE: inject accordion + dedicated + button

     Goal:
       • SHOP text → navigates to its href normally
       • + button injected beside SHOP → toggles accordion
       • Accordion injected as sibling <li> after SHOP <li>

     Dawn drawer structure we target:
       <ul>
         <li>              ← shopLi
           <a>SHOP</a>     ← or <details><summary>SHOP</summary></details>
         </li>
         ← we insert accordion here
       </ul>
  ───────────────────────────────────────────────── */
  function bindMobileAccordion() {
    if (mobileBound) return;

    var template = document.getElementById('megaMenuMobileAccordion');
    if (!template) return;

    var drawerCandidates = document.querySelectorAll([
      '#menu-drawer a',
      '#menu-drawer summary',
      'nav-drawer a',
      'nav-drawer summary',
      '.menu-drawer__navigation a',
      '.menu-drawer__navigation summary',
      '[id*="menu-drawer"] a',
      '[id*="menu-drawer"] summary'
    ].join(','));

    if (!drawerCandidates.length) { setTimeout(bindMobileAccordion, 300); return; }

    var injected = false;

    drawerCandidates.forEach(function(el) {
      if (injected) return;
      var text = (el.querySelector('span') || el).textContent;
      if (!isMatch(text)) return;

      var li = el.closest('li') || el.parentElement;
      if (!li) return;

      /* Don't inject twice */
      if (li.dataset.mmMobileDone) return;
      li.dataset.mmMobileDone = 'true';

      /* ── 1. Inject + button beside SHOP in the drawer row ── */
      var toggleBtn = document.createElement('button');
      toggleBtn.className = 'mm-shop-toggle';
      toggleBtn.setAttribute('aria-label', 'Open shop menu');
      toggleBtn.setAttribute('aria-expanded', 'false');
      toggleBtn.type = 'button';
      toggleBtn.textContent = '+';

      /* Wrap the existing content + our button in a flex row */
      var row = document.createElement('div');
      row.className = 'mm-shop-row';

      /* Move the existing child (the <a> or <details>) into the row */
      while (li.firstChild) row.appendChild(li.firstChild);
      row.appendChild(toggleBtn);
      li.appendChild(row);

      /* Make sure the SHOP <a> or <summary> navigates normally —
         suppress any existing Dawn preventDefault on <summary>   */
      var shopLink = row.querySelector('a');
      var shopSummary = row.querySelector('summary');

      if (shopSummary) {
        /* Replace summary click — let the <a> inside it navigate */
        shopSummary.addEventListener('click', function(e) {
          /* If click was on the summary itself (not the toggle btn), navigate */
          if (!e.target.closest('.mm-shop-toggle')) {
            var href = shopSummary.querySelector('a');
            if (href) window.location.href = href.getAttribute('href');
          }
          e.preventDefault();
          e.stopImmediatePropagation();
        }, true);
      }

      /* ── 2. Inject accordion after the SHOP <li> ── */
      var clone = document.importNode(template.content, true);
      li.parentNode.insertBefore(clone, li.nextSibling);

      /* ── 3. Wire the + button to show/hide accordion ── */
      var accordion = li.nextElementSibling;

      toggleBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        var isOpen = accordion.classList.contains('is-open');
        if (isOpen) {
          accordion.classList.remove('is-open');
          toggleBtn.textContent = '+';
          toggleBtn.setAttribute('aria-expanded', 'false');
          toggleBtn.setAttribute('aria-label', 'Open shop menu');
        } else {
          accordion.classList.add('is-open');
          toggleBtn.textContent = '−';
          toggleBtn.setAttribute('aria-expanded', 'true');
          toggleBtn.setAttribute('aria-label', 'Close shop menu');
        }
      });

      injected = true;
    });

    if (!injected) { setTimeout(bindMobileAccordion, 300); return; }

    /* ── 4. Wire each sub-group +/- toggle inside accordion ── */
    document.querySelectorAll('.mm-mobile-group-toggle').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        /* Don't let the sub-group heading <a> navigate when clicking the button */
        var sublist = btn.nextElementSibling;
        if (!sublist) return;
        var isExpanded = btn.getAttribute('aria-expanded') === 'true';

        if (isExpanded) {
          btn.setAttribute('aria-expanded', 'false');
          btn.querySelector('.mm-mobile-icon').textContent = '+';
          sublist.classList.remove('is-open');
          setTimeout(function() { sublist.setAttribute('hidden', ''); }, 280);
        } else {
          btn.setAttribute('aria-expanded', 'true');
          btn.querySelector('.mm-mobile-icon').textContent = '−';
          sublist.removeAttribute('hidden');
          requestAnimationFrame(function() { sublist.classList.add('is-open'); });
        }
      });
    });

    mobileBound = true;
  }

  /* ─────────────────────────────────────────────────
     GLOBAL EVENT WIRING
  ───────────────────────────────────────────────── */
  panel.addEventListener('mouseenter', cancelClose);
  panel.addEventListener('mouseleave', scheduleClose);
  backdrop.addEventListener('click', closeMenu);
  closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMenu(); });

  window.addEventListener('scroll', function(){
    if (isOpen) panel.style.top = getHeaderBottom() + 'px';
  }, { passive: true });

  window.addEventListener('resize', function(){
    if (isOpen) panel.style.top = getHeaderBottom() + 'px';
  });

  /* ─────────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────────── */
  function init() {
    bound = false;
    mobileBound = false;
    markTriggers();
    bindDesktopTriggers();
    bindMobileAccordion();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();